// Invalid Attachment Validation
export const INVALID_ATTACHMENT = "Unable to access this attachment at the moment.";
export const ATTACH_MANUALLY = "Please attach the document manually.";
